let apiUrl;



let reg = /\S+(?=\/\w+.html)/;
let str = window.location.pathname.match(reg)?.[0];
switch (process.env.VUE_APP_API_ENV) {
    case "development":
    apiUrl = "";
    break;
    case "uat":
    apiUrl = "https://kiacarservice-uat.kia.cn";
    break;
    case "production":
    apiUrl = "https://kiacarservice.kia.cn";
    break;
    default:
    apiUrl = "";
    break;
}


export { apiUrl};
